import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';

import TextField from '@gef-ui/form-material/TextField';
import { getLabelMessage } from '@gef-ui/localization/messages';

import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import { MaxLengths } from 'constants/forms';
import { FIELDS } from 'features/views/campaignSettings/campaignDetail/form';

export const Description = () => (
	<Paper sx={{ p: 3, borderRadius: 2 }}>
		<Stack spacing={2}>
			<SectionHeader text={getLabelMessage('campaign:descriptionTitle')} />
			<Grid container>
				<Grid size={12}>
					<Grid container>
						<Grid size={12}>
							<TextField
								size="small"
								fieldName={FIELDS.description}
								label={getLabelMessage('campaign:description')}
								multiline
								slotProps={{
									htmlInput: {
										maxLength: MaxLengths.NOTE,
									},
								}}
							/>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Stack>
	</Paper>
);

export default Description;
